import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { LogOut } from "lucide-react";
import { api, money } from "../lib/api";
import { STATUS_LABELS } from "../lib/i18n";
import { useLang } from "../context/LangContext";
import { useAuth } from "../context/AuthContext";
import { LoginPanel } from "../components/store/LoginPanel";

export default function Account() {
  const { t, lang } = useLang();
  const { user, logout } = useAuth();
  const [orders, setOrders] = useState([]);

  useEffect(() => {
    if (user) api.get("/my/orders").then((r) => setOrders(r.data));
  }, [user]);

  if (user === null) return <div className="container-q py-32" />;

  if (!user) {
    return (
      <div data-testid="account-login" className="container-q grid items-center gap-12 py-14 sm:py-20 lg:grid-cols-2">
        <div className="flex flex-col items-start">
          <p className="eyebrow mb-4">{t("account")}</p>
          <LoginPanel />
          <Link to="/track" className="link-u mt-6 text-sm">{t("track_order")}</Link>
        </div>
        <img src="/images/daily.jpg" alt="" className="hidden aspect-[4/5] w-full object-cover lg:block" />
      </div>
    );
  }

  return (
    <div data-testid="account-page" className="container-q pb-28 pt-16">
      <div className="flex flex-wrap items-end justify-between gap-6 border-b border-sand pb-8">
        <div className="flex items-center gap-5">
          {user.picture && <img src={user.picture} alt="" className="h-14 w-14 rounded-full object-cover" />}
          <div>
            <h1 className="text-3xl sm:text-4xl">{t("hello")}، {user.name}</h1>
            <p className="text-sm text-sand-dark">{user.email}</p>
          </div>
        </div>
        <button data-testid="logout-button" onClick={logout} className="flex items-center gap-2 text-sm"><LogOut size={15} strokeWidth={1.3} />{t("logout")}</button>
      </div>
      <h2 className="mb-6 mt-12 font-display text-2xl">{t("my_orders")}</h2>
      {!orders.length && <p className="text-sm text-sand-dark">—</p>}
      <div className="divide-y divide-sand border-y border-sand">
        {orders.map((o) => (
          <div key={o.order_number} data-testid={`my-order-${o.order_number}`} className="grid grid-cols-2 gap-3 py-5 text-sm sm:grid-cols-4">
            <span className="font-latin">{o.order_number}</span>
            <span>{new Date(o.created_at).toLocaleDateString(lang === "ar" ? "ar-SA" : "en-GB")}</span>
            <span>{STATUS_LABELS[o.status]?.[lang]}</span>
            <span className="sm:text-end">{money(o.total)} {t("sar")}</span>
          </div>
        ))}
      </div>
    </div>
  );
}
